import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="news-fund-like"
export default class extends Controller {
  connect() {
    this.element.querySelectorAll('.ranking_heart span').forEach((ele) => {
      const fundId = ele.className.match(/heart_span_(.+)$/)[1]
      const parentContainerNode = ele.parentNode
      this.fetchHeart(parentContainerNode, fundId)
    })
  }

  async fetchHeart(ele, fundId){
    const reqUrl = '/fund_fav_btns/' + fundId
    const resp = await get(reqUrl)
    ele.innerHTML = await resp.html
  }
}
